// Job Professions
import {
  VuexModule, Module, Mutation, Action, getModule,
} from 'vuex-module-decorators';

import store from '@/store';

import { ICourse } from '@/types/courses/Courses';
import {
  DEFAULT_COURSE_COUNT,
  DEFAULT_AVGS_FILTER,
  DEFAULT_PAGE,
  DEFAULT_LIMIT_PER_PAGE,
  DEFAULT_PROFESSION_GROUP_ID,
} from '@/config/courses';
import { fetchCoursesList } from '@/api/Courses';

// import jobGroupsStore from '@/store/modules/jobGroups';

export interface IProfessionData {
  name: string
  id: string
}

export interface ICourseState {
  courses: ICourse[]
  coursesCount: number
  currentPage: number
  limitPerPage: number
  avgs_filter: number
  profession_filters: string
  professionName: string
  isLoading: boolean
}

@Module({ store, name: 'coursesState', dynamic: true })
class Courses extends VuexModule implements ICourseState {
  coursesCount = DEFAULT_COURSE_COUNT;

  currentPage = DEFAULT_PAGE;

  limitPerPage = DEFAULT_LIMIT_PER_PAGE;

  profession_filters = DEFAULT_PROFESSION_GROUP_ID;

  professionName = '';

  courses: ICourse[] = [];

  avgs_filter = DEFAULT_AVGS_FILTER;

  isLoading = false;

  get coursesForModal(): ICourse[] {
    return this.courses.filter((item) => !item.show_in_new_tab);
  }

  @Mutation
  SET_COURSES_LIST(courses: ICourse[]) {
    this.courses = courses;
  }

  @Mutation
  SET_COURSES_COUNT(count?: ICourseState['coursesCount']) {
    if (count) {
      this.coursesCount = count;
    } else {
      this.coursesCount = DEFAULT_COURSE_COUNT;
    }
  }

  @Mutation
  SET_PROFESSION_FILTERS(profession: IProfessionData) {
    this.profession_filters = profession.id;
    this.professionName = profession.name;
  }

  @Mutation
  SET_CURRENT_PAGE(page = DEFAULT_PAGE) {
    this.currentPage = page;
  }

  @Mutation
  SET_LIMIT_PER_PAGE(size = DEFAULT_LIMIT_PER_PAGE) {
    this.limitPerPage = size;
  }

  @Mutation
  SET_LOADING(status: boolean) {
    this.isLoading = status;
  }

  @Mutation
  SET_AVGS_FILTER(value = DEFAULT_AVGS_FILTER) {
    this.avgs_filter = value;
  }

  @Action
  RESET_FILTERS() {
    this.SET_CURRENT_PAGE();
    this.SET_LIMIT_PER_PAGE();
    this.SET_COURSES_COUNT();
    this.SET_AVGS_FILTER();
  }

  @Action
  async HANDLE_COURSES_LIST(payload: IProfessionData & { sid: string }) {
    if (payload.id === this.profession_filters) return;

    this.SET_PROFESSION_FILTERS(payload);
    this.RESET_FILTERS();
    await this.FETCH_COURSES_LIST(payload.sid);
  }

  @Action
  async FETCH_COURSES_LIST(sid: string) {
    const params = {
      page: this.currentPage,
      size: this.limitPerPage,
      avgs_filter: this.avgs_filter,
      profession_filters: this.profession_filters,
      sid,
    };

    this.SET_LOADING(true);

    const { courses, total_course_count } = await fetchCoursesList(params);

    this.SET_LOADING(false);

    this.SET_COURSES_COUNT(total_course_count);
    this.SET_COURSES_LIST(courses);
  }
}

export const CoursesModule = getModule(Courses);
